import React, { useEffect, useState } from "react";
import styled from "styled-components";
import useTokenStore from "../Store/Store";
import Prev from "../../img/PrevWhite.png"
import NagasakiImg from "../../img/NagasakiImg.png"
import ChoiceImg from "../../img/Choice.png"
import NoChoiceImg from "../../img/NoChoice.png"
import ChoiceImg2 from "../../img/Choice2.png"
import NoChoiceImg2 from "../../img/NoChoice2.png"
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';
import CompanyInfo from "../MenuCompo/CompanyInfo";

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        flex-direction:column;
    `,

        Header:styled.div`
            width:90%;
            height:24px;
            display:flex;
            justify-content:flex-start;
            align-items:center;
            flex-direction:row;
            position:fixed;
            z-index:3;
            top:20px;
        `,
            PrevBtn:styled.div`
                width:24px;
                height:24px;
                &:hover{
                    cursor:pointer;
                }
            `,
                PrevImg:styled.img`
                    width:100%;
                    height:100%;
                `,
        MenuImgBox:styled.div`
            width:100%;
            height:220px;
        `,
            MenuImg:styled.img`
                width:100%;
                height:100%;
            `,
        ContentBox:styled.div`
            width:90%;
            height:auto;
            display:flex;
            justify-content:flex-start;
            align-items:flex-start;
            flex-direction:column;
            padding:10px;
        `,
            Title:styled.p`
                font-size:20px;
                font-weight:700;
                color:#181818;
                font-family:'PreFont';
                margin-top:0px;
                margin-bottom:0px;
            `,
            ContentText:styled.p`
                font-size:14px;
                font-weight:400;
                color:#767676;
                font-family:'PreFont';
                margin:0px;
            `,
        Bar:styled.div`
            width:100%;
            height:10px;
            background-color:#F5F5F5;
        `,
        PriceBox:styled.div`
            width:90%;
            height:48px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:row;
        `,
            PriceText:styled.p`
                font-size:16px;
                font-weight:600;
                color:#000000;
                font-family:'PreFont';
                margin:0px;
            `,
        ChoiceWrap:styled.div`
            width:90%;
            height:auto;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:column;
        `,
            ChoiceTitleBox:styled.div`
                width:100%;
                height:42px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:row;
            `,
                ChoiceTitle:styled.p`
                    font-size:16px;
                    font-weight:600;
                    color:#000000;
                    font-family:'PreFont';
                    margin:0px;
                `,
                EssentialBox:styled.div`
                    width:auto;
                    height:auto;
                    padding:4px 6px 4px 6px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    flex-direction:row;
                    background-color:#DCEAFF;
                    border-radius:6px;
                `,
                    EssentialText:styled.p`
                        font-size:12px;
                        font-weight:600;
                        color:#2277F6;
                        font-family:'PreFont';
                        margin:0px;
                    `,
                NoEssentialBox:styled.div`
                    width:auto;
                    height:auto;
                    padding:4px 6px 4px 6px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    flex-direction:row;
                    background-color:#ECECEC;
                    border-radius:6px;
                `,
                    NoEssentialText:styled.p`
                        font-size:12px;
                        font-weight:600;
                        color:#767676;
                        font-family:'PreFont';
                        margin:0px;
                    `,
            ChoiceBox:styled.div`
                width:100%;
                height:56px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:row;
            `,
                ChoiceBtnBox:styled.div`
                    width:auto;
                    height:auto;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    flex-direction:row;
                `,
                    ChoiceBtnText:styled.p`
                        font-size:16px;
                        font-weight:600;
                        color:#000000;
                        font-family:'PreFont';
                        margin:0px 0px 0px 10px;
                    `,
        NumberWrap:styled.div`
            width:90%;
            height:auto;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:row;
            padding:10px;
        `,
            NumberBtnWrap:styled.div`
                width:86px;
                height:30px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:row;
            `,

        Nothing:styled.div`
            width:100%;
            height:100px;
        `,
        Footer:styled.div`
            width:100%;
            height:100px;
            display:flex;
            justify-content:center;
            align-items:flex-start;
            flex-direction:row;
            background-color:#ffffff;
            z-index:3;
            position:fixed;
            bottom:0;
            box-shadow: 0px 0px 20px #eeeeee;
        `,
            CallBtn:styled.div`
                width:90%;
                height:50px;
                border-radius:10px;
                background-color:#2277F6;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
                margin-top:10px;
            `,
                BtnText:styled.p`
                    font-size:16px;
                    font-weight:400;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                `,
}
const MenuChange=(props)=>{
    const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);
    const location = useLocation();
    const { someData, INDEX } = location.state || {};
    
    const [uuid, setuuid]=useState(undefined)
    useEffect(()=>{
        const saved_uuid_data = JSON.parse(localStorage.getItem("uuid_data"));
        console.log(saved_uuid_data)
        setuuid(saved_uuid_data)
    },[])
    const navigate = useNavigate();
    const {ChoiceMenu, setChoiceMenu, OpenMenu, setOpenMenu} = props
    const {
        Menu,
        setMenu,
        GoMenu,
        setGoMenu,
        Pocket,
        setPocket,
    } = useTokenStore()

    useEffect(()=>{
        console.log(someData)
    }, [someData])
    const [ChoiceIDX, setChoiceIDX] = useState(-1);
    const [SelectedTaste2, setSelectedTaste2] = useState([]); // 여러 항목의 선택 상태 관리
    const [OrderNum, setOrderNum] = useState(1)

    const toggleTaste2Selection = (idx) => {
        if (SelectedTaste2.includes(idx)) {
            // 이미 선택된 항목이면 해제
            setSelectedTaste2(SelectedTaste2.filter((item) => item !== idx));
        } else {
            // 선택되지 않은 항목이면 추가
            setSelectedTaste2([...SelectedTaste2, idx]);
        }
    };

    useEffect(()=>{
        setGoMenu(false)
    },[])
    function addCommasEveryThirdDigit(number) {
        return number.toLocaleString('en-US');
    }
    const MenuImgBox=styled.div`
        width:100%;
        height:220px;
        background: linear-gradient(
            to top,
            rgba(20, 20, 20, 0) 70%,
            rgba(20, 20, 20, 0.1) 75%,
            rgba(20, 20, 20, 0.15) 85%,
            rgba(20, 20, 20, 0.20) 90%,
            rgba(20, 20, 20, 0.25) 100%
        ),
        url(${someData[0].Img});
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    `;
    function Minus(){
        if(OrderNum===1){

        }else{
            setOrderNum(OrderNum-1)
        }
    }

    const ChoiceBtn = styled.div`
        width: 24px;
        height: 24px;
        background-image: url(${props => props.checked ? ChoiceImg : NoChoiceImg}); // 선택 여부에 따라 이미지 변경
        &:hover {
            cursor: pointer;
        }
    `;
    const ChoiceBtn2 = styled.div`
        width: 24px;
        height: 24px;
        background-image: url(${props => props.checked ? ChoiceImg2 : NoChoiceImg2}); // 선택 여부에 따라 이미지 변경
        &:hover {
            cursor: pointer;
        }
    `;
    const [Categori, setCategori]=useState(undefined)
    useEffect(() => {
        const loadData = async () => {      
          // 1. 레스토랑 데이터 먼저 처리
          const savedData = localStorage.getItem("restaurant_data");
          if (savedData) {
            try {
              const parsed = JSON.parse(savedData);
              if (parsed.expiresAt && parsed.expiresAt > Date.now()) {
                // setRestaurantInfo(parsed.data);
                console.log(parsed.data.categories)
                setCategori(parsed.data.categories)
              } else {
                // 데이터가 만료됨
                localStorage.removeItem("restaurant_data");
              }
            } catch (err) {
              localStorage.removeItem("restaurant_data");
            }
          } 
          // 2. 테이블 정보 가져오기
        };
      
        loadData();
    }, [uuid]);


    const [ChangeMenuData, setChangeMenuData] = useState(undefined)
    function findItemById(Data, id) {
        for (const category of Data) {
          if (category.id === id) {
            return category; // 카테고리 ID가 일치할 경우
          }
      
          const foundMenu = category.menus.find(menu => menu.id === id);
          if (foundMenu) {
            setChangeMenuData(foundMenu)
            return foundMenu; // 메뉴 ID가 일치할 경우
          }
        }
      
        return null; // 찾지 못했을 경우
    }
    useEffect(()=>{
        if(Categori){
            findItemById(Categori, someData[0].Id)
        }
    }, [Categori])




    function ChangePocket() {
        const selectedAzi = ChangeMenuData.option[ChoiceIDX]; // object 하나
        const selectedAdditional = SelectedTaste2.map((idx) => ChangeMenuData.additional[idx]); // object 배열
        const newItem = [{
            Name: ChangeMenuData.names,
            Azi: selectedAzi,
            Additional:selectedAdditional,
            Num: OrderNum,
            Price: ChangeMenuData.price,
            Img: ChangeMenuData.image,
            Id:someData[0].Id
        }];
    
        // Pocket 배열을 복사하면서 특정 INDEX 위치의 데이터를 수정
        const updatedPocket = Pocket.map((item, idx) => {
            if (idx === INDEX) {
                return newItem; // INDEX와 같은 인덱스의 데이터 수정
            }
            return item; // 나머지는 그대로 유지
        });
    
        // Pocket 배열 업데이트
        setPocket(updatedPocket);
        
        navigate(`/cart/${uuid}`);
    }
    
    const [CostText, setCostText] = useState({
        "KR":"가격",
        "EN":"price",
        "CN":"价格",
        "JP":"価格",
        "FR":"prix",
        "SP":"precio",
        "GR":"Preis",
        "RU":"стоимость"
    })
    const [NumText, setNumText] = useState({
        "KR":"수량",
        "EN":"quantity",
        "CN":"数量",
        "JP":"数量",
        "FR":"quantité",
        "SP":"cantidad",
        "GR":"Anzahl",
        "RU":"количество"
    })
    const [AddToCartText, setAddToCartText] = useState({
        "KR":"장바구니에 담기",
        "EN":"Add to cart",
        "CN":"加入购物车",
        "JP":"カートに入れる",
        "FR":"Ajouter au panier",
        "SP":"Añadir al carrito",
        "GR":"In den Warenkorb legen",
        "RU":"Добавить в корзину"
    })
    const [WonText, setWonText] = useState({
        "KR":"원",
        "EN":"won",
        "CN":"won",
        "JP":"ウォン",
        "FR":"won",
        "SP":"won",
        "GR":"won",
        "RU":"won"
    })
    





    



    if(ChangeMenuData === undefined){
        <></>
    }else{
        return(
            <Styled.Wrap>
                <Styled.Header>
                    <Styled.PrevBtn onClick={() => navigate(`/cart/${uuid}`)}>
                        <Styled.PrevImg src={Prev}/>
                    </Styled.PrevBtn>
                </Styled.Header>
                
                <Styled.MenuImgBox>
                    <Styled.MenuImg src={`https://zzikgomainapi.co.kr${ChangeMenuData.image}`}/>
                </Styled.MenuImgBox>
                {/* <MenuImgBox /> */}
                <Styled.ContentBox>
                    <Styled.Title>{ChangeMenuData.names[Langcookies["PageLang"]]}</Styled.Title>
                    <Styled.ContentText>{ChangeMenuData.descriptions[Langcookies["PageLang"]]}</Styled.ContentText>
                </Styled.ContentBox>
                <Styled.Bar />
                <Styled.PriceBox>
                    <Styled.PriceText>{CostText[Langcookies["PageLang"]]}</Styled.PriceText>
                    <Styled.PriceText>{addCommasEveryThirdDigit(ChangeMenuData.price)}</Styled.PriceText>
                </Styled.PriceBox>
                <Styled.Bar />
                <Styled.ChoiceWrap>
                    <Styled.ChoiceTitleBox>
                        <Styled.ChoiceTitle>옵션</Styled.ChoiceTitle>
                        <Styled.EssentialBox>
                            <Styled.EssentialText>필수</Styled.EssentialText>
                        </Styled.EssentialBox>
                    </Styled.ChoiceTitleBox>
                    {/* {Taste.map((v, idx) => (
                        <Styled.ChoiceBox key={idx} onClick={() => setChoiceIDX(idx)}>
                            <Styled.ChoiceBtnBox>
                                <ChoiceBtn
                                    checked={ChoiceIDX === idx}
                                    onClick={() => setChoiceIDX(idx)}
                                />
                                <Styled.ChoiceBtnText>맵기 {v}단계</Styled.ChoiceBtnText>
                            </Styled.ChoiceBtnBox>
                            <Styled.ChoiceBtnText>+0{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                        </Styled.ChoiceBox>
                    ))} */}
                    {ChangeMenuData.option.map((v, idx) => {
                        const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                        const value = v[key]; // 예: 0
                        return (
                            <Styled.ChoiceBox key={idx} onClick={() => setChoiceIDX(idx)}>
                                <Styled.ChoiceBtnBox>
                                    <ChoiceBtn
                                        checked={ChoiceIDX === idx}
                                        onClick={() => setChoiceIDX(idx)}
                                      />
                                    <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                                </Styled.ChoiceBtnBox>
                                <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBox>
                        );
                    })}
                </Styled.ChoiceWrap>
                <Styled.Bar />
                <Styled.ChoiceWrap>
                    <Styled.ChoiceTitleBox>
                        <Styled.ChoiceTitle>추가메뉴</Styled.ChoiceTitle>
                        <Styled.NoEssentialBox>
                            <Styled.NoEssentialText>선택</Styled.NoEssentialText>
                        </Styled.NoEssentialBox>
                    </Styled.ChoiceTitleBox>
                    {ChangeMenuData.additional.map((v, idx) => {
                        const key = Object.keys(v)[0]; // 예: "추가선택 이름"
                        const value = v[key]; // 예: 0
    
                        return (
                            <Styled.ChoiceBox key={idx} onClick={() => toggleTaste2Selection(idx)}>
                                <Styled.ChoiceBtnBox>
                                    <ChoiceBtn2
                                        checked={SelectedTaste2.includes(idx)} // 선택 상태 확인
                                        onClick={() => toggleTaste2Selection(idx)}
                                    />
                                    <Styled.ChoiceBtnText>{key}</Styled.ChoiceBtnText>
                                </Styled.ChoiceBtnBox>
                                <Styled.ChoiceBtnText>+{value}{WonText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                            </Styled.ChoiceBox>
                        );
                    })}
                </Styled.ChoiceWrap>
                <Styled.Bar />
                <Styled.NumberWrap>
                    <Styled.ChoiceBtnText>{NumText[Langcookies["PageLang"]]}</Styled.ChoiceBtnText>
                    <Styled.NumberBtnWrap>
                        <Styled.ChoiceBtnText onClick={Minus}>-</Styled.ChoiceBtnText>
                        <Styled.ChoiceBtnText>{OrderNum}</Styled.ChoiceBtnText>
                        <Styled.ChoiceBtnText onClick={()=>setOrderNum(OrderNum+1)}>+</Styled.ChoiceBtnText>
                    </Styled.NumberBtnWrap>
                </Styled.NumberWrap>
                <CompanyInfo />
                <Styled.Footer>
                    <Styled.CallBtn onClick={()=>{ChangePocket()}}>
                        <Styled.BtnText>{AddToCartText[Langcookies["PageLang"]]}</Styled.BtnText>
                    </Styled.CallBtn>
                </Styled.Footer>
                <Styled.Nothing />
            </Styled.Wrap>
        )
    }

}
export default MenuChange